import reducer from "./reducer";
export { default as Poll } from "./components/index";
export { default as pollReducerName } from "./constants";
export default reducer;
